import { LegacySingleType, Type } from '../../typeParser';
import { isCallback } from '../../OperationDetails/JSOperationView/CallbacksTableDisplay';
import { Operation } from '../../../../../types';
import { getMdHeadingId } from '../../../../../utils/locationUtils';
import { getCallback } from '../../../../../utils/typeUtils';

export const shouldPresentTypeAsCallbackLink = (metaData: Object): boolean => {
  return isCallback({ metaData });
};

export const getCallbackIfNeeded = (
  type: Type | LegacySingleType,
  metaData: Object,
  store,
): null | Operation => {
  return isCallback({ metaData }) ? getCallback(type, store) : null;
};

export const getCallbackLink = (
  callback: Operation,
  path: string,
): { pathname: string; hash: string } => {
  const id = getMdHeadingId(path, callback.urlFormat);
  return {
    pathname: `/${path}`,
    hash: id,
  };
};
